import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { url: String };
  static targets = ['saveError'];

  async save() {
    if (this.saving) return;

    const body = new FormData(this.element);
    const controls = Array.from(this.element.elements).filter((control) => !control.disabled);
    this.saving = true;
    this.element.setAttribute('aria-busy', 'true');
    controls.forEach((control) => (control.disabled = true));
    this.saveErrorTarget.hidden = true;

    try {
      const headers = { Accept: 'text/vnd.turbo-stream.html' };
      const csrf = document.querySelector('meta[name="csrf-token"]');
      if (csrf) headers['X-CSRF-Token'] = csrf.content;
      const response = await fetch(this.urlValue, { method: 'PATCH', headers, body });
      if (response.redirected) {
        Turbo.visit(response.url);
        return;
      }
      if (!response.headers.get('content-type')?.includes('text/vnd.turbo-stream.html')) {
        throw new Error('Unexpected response');
      }
      Turbo.renderStreamMessage(await response.text());
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      this.saveFailed = false;
    } catch {
      this.saveFailed = true;
      this.saveErrorTarget.hidden = false;
    } finally {
      this.saving = false;
      this.element.removeAttribute('aria-busy');
      controls.forEach((control) => (control.disabled = false));
      this.submitButtons.forEach((button) => (button.disabled = this.saveFailed));
    }
  }

  submit(event) {
    if (this.saving || this.saveFailed) event.preventDefault();
  }

  get submitButtons() {
    return Array.from(this.element.elements).filter((control) => control.type === 'submit');
  }
}
